'use strict';

class DatosEmpresaController {
  constructor() {

  }


}

export default DatosEmpresaController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/datos-empresa/datos-empresa.controller.js